import { Badge as MuiBadge, Stack, styled } from '@mui/material'
import { MouseEvent, ReactNode } from 'react'
import { AddIcon } from '@weblite/icons'

export function StoryAvatarBadge({
  invisible,
  children,
  onClick,
}: {
  invisible?: boolean
  children: ReactNode
  onClick?: (e: MouseEvent<HTMLDivElement>) => void
}) {
  return (
    <Badge
      overlap="circular"
      onClick={onClick}
      invisible={invisible}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      sx={{ cursor: onClick ? 'pointer' : undefined }}
      badgeContent={
        <BadgeContainer>
          <AddIcon
            sx={{ color: 'neutral000', width: '16px', height: '16px' }}
          />
        </BadgeContainer>
      }
    >
      {children}
    </Badge>
  )
}

const Badge = styled(MuiBadge)`
  &.MuiBadge-root {
    width: fit-content;
    height: fit-content;
    padding: 0;
  }
`
const BadgeContainer = styled(Stack)`
  width: 22px;
  height: 22px;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  border: 2px solid white;
  background: ${({ theme }) => theme.palette.storyGradientH};
`
